export interface ApplicationTransactionProps {
  applicationId: number;
  id: number;
  orderType: OrderTypeEnum;
  processingStatusId: ProcessingStatusEnum;
  errorMessage: string | null;
}

export enum ProcessingStatusEnum {
  Queued = 1,
  Processing = 2,
  Succeeded = 3,
  Failed = 4,
  Cancelled = 5,
}

export enum OrderTypeEnum {
  RecognitionMaterials = 0,
  ApplicationFee = 1,
}
